import { createSelector } from "reselect";

import { MainNavigationStore } from "../stores/types";

export const selectNavigationIsExpanded = createSelector(
  (state: MainNavigationStore) => state.isSidebarExpanded,
  (state: MainNavigationStore) => state.mobileFullScreen,
  (isSidebarExpanded, mobileFullScreen): boolean => isSidebarExpanded || mobileFullScreen
);
